/* eslint-disable react/no-array-index-key */
import React from 'react';

const renderTags = contentDocumentHead => {
  if (!Array.isArray(contentDocumentHead)) {
    return null;
  }

  return contentDocumentHead.map(({ type, props, content }, index) => {
    const TagName = type;
    if (type === 'meta') {
      return <TagName {...props} key={index} />;
    }
    return (
      <TagName {...props} key={index}>
        {content}
      </TagName>
    );
  });
};

export default renderTags;
